import React from 'react';
import { DoctorComment } from './DoctorComment';
export function ArticleBody() {
  return <article className="text-lg leading-relaxed text-[#1B1B2F]" data-id="element-1">
      <p className="text-xl text-gray-600 italic mb-8" data-id="element-2">
        Aus der Redaktion: Diese Geschichte hat uns Anna M. aus Stuttgart
        geschickt. Wir haben uns entschlossen, sie in voller Länge zu
        veröffentlichen und mit Kommentaren des führenden Experten für
        Alters-Ernährungsmedizin Dr. Lippert zu ergänzen, um andere vor
        demselben Fehler zu bewahren.
      </p>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-3">
        Die Falle der „Hochdosis" und das Echo der Pandemie
      </h2>
      <p className="mb-4" data-id="element-4">
        Alles begann vor ein paar Jahren. Aus jedem Lautsprecher schallte es:
        „Trinken Sie Vitamin D! Es ist das Allheilmittel gegen Covid, gegen
        Depressionen, gegen das Altern." Als bewusster Mensch beschloss ich,
        nicht an meiner Gesundheit zu sparen.
      </p>
      <p className="mb-4" data-id="element-5">
        Ich ging ins Internet, gab „Vitamin D3“ ein und wählte die Dose mit der
        höchsten Dosierung und tausenden begeisterten Bewertungen.
      </p>
      <p className="mb-4" data-id="element-6">
        Ich nahm es streng nach Anleitung – alle drei Tage. Im ersten Monat
        spürte ich gar nichts. Dann bemerkte ich eine leichte Energie,
        Vitalität. Und mit dem Gefühl, meinem Körper nur Gutes zu tun, machte
        ich weiter… Monat für Monat.
      </p>

      <DoctorComment data-id="element-7">
        <p className="mb-2" data-id="element-8">
          <strong className="font-[600]" data-id="element-9">
            Annas größter Fehler ist der „Marktplatz-Ansatz" in der Medizin.
          </strong>
        </p>
        <p data-id="element-10">
          Massenmarkt-Marken wetteifern oft um die Zahlen auf dem Etikett
          (10.000 IE, 20.000 IE), um Käufer anzulocken. Aber der Organismus ab
          50 Jahren ist kein Fass ohne Boden. Ohne verbindende Komponenten
          können solche Dosen toxisch werden. „Mehr" bedeutet in diesem Alter
          fast nie „besser".
        </p>
      </DoctorComment>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-11">
        Ein Vorfall, den ich anfangs nicht ernst nahm
      </h2>
      <p className="mb-4" data-id="element-12">
        Nach sieben Monaten der Einnahme passierte etwas Seltsames. Eines Tages
        zu Hause stieß ich versehentlich mit dem Ellenbogen gegen die Kante
        eines Schranks. Der Schlag war schwach – ich spürte fast keinen Schmerz.
        Am nächsten Tag war der Ellenbogen geschwollen. Ich dachte, es sei eine
        normale Prellung. Doch nach einigen Tagen ging die Schwellung nicht
        zurück, Schmerzen traten auf und ich ging schließlich doch zum Arzt. Man
        machte ein Röntgenbild. Die Diagnose kam unerwartet: Bruch der Elle
        (Ulna).
      </p>

      <figure className="my-8" data-id="element-13">
        <img src="https://cdn.magicpatterns.com/uploads/7qexUL8WXVeKX5QCU2UEJT/114.jpg" alt="Röntgenaufnahme: Fraktur der Elle (Ulna)" className="w-full rounded-lg shadow-md" data-id="element-14" />
        <figcaption className="text-sm text-center text-gray-500 mt-2 italic" data-id="element-15">
          Röntgenaufnahme des rechten Ellenbogengelenks – Anna M., 55 Jahre.
          Sichtbare rechtsseitige Olecranonfraktur der Ulna; der Pfeil markiert
          die Frakturlinie im proximalen Olecranon.
        </figcaption>
      </figure>

      <p className="mb-4" data-id="element-16">
        Ich konnte es nicht glauben. Der Schlag war viel zu schwach. Man legte
        mir einen Gips an. Es hieß – 1,5 Monate. Aber in meinem Fall dauerte es
        fast vier Monate, bis der Knochen wieder vollständig geheilt war. Das
        Seltsamste – die Analysen zeigten, dass mein Vitamin-D-Spiegel im Blut
        ideal war, sogar über der Norm.
      </p>

      <figure className="my-8" data-id="element-17">
        <img src="https://cdn.magicpatterns.com/uploads/t1DWfenGepeWPV6USqBnrL/52.jpg" alt="Ich bin im Krankenhaus" className="w-full rounded-lg shadow-md" data-id="element-18" />
        <figcaption className="text-sm text-center text-gray-500 mt-2 italic" data-id="element-19">
          Selbst ein leichter Stoß führte zu einer Fraktur der Ulna. Die
          Heilungsdauer betrug fast 4 Monate statt 1,5.
        </figcaption>
      </figure>

      <DoctorComment data-id="element-20">
        <p className="mb-2" data-id="element-21">
          <strong data-id="element-22">Das ist das klassische Paradoxon.</strong>
        </p>
        <p data-id="element-23">
          Ein hoher D3-Spiegel im Blut ohne die Kontrolle von „Wegweisern"
          arbeitet gegen Sie. Vitamin D3 erhöht die Kalziumaufnahme drastisch,
          aber wenn niemand da ist, der es in den Knochen „einparkt", beginnt
          es, altes Kalzium aus den Knochen zu lösen, um den Spiegel im Blut
          aufrechtzuerhalten. Der Knochen wird „porös" und brüchig wie Zwieback.
          Auf Annas Röntgenbild sahen wir eine Abnahme der Knochendichte
          (Osteopenie) vor dem Hintergrund eines Vitaminüberschusses. Selbst
          wenn der Kalziumspiegel im Blut ausreichend ist, bedeutet das nicht,
          dass genügend davon in den Knochen ist. Genau deshalb zeigen allein
          „gute Blutwerte" nicht immer das vollständige Bild.
        </p>
      </DoctorComment>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-24">
        Der Fehler, den ich damals nicht verstand
      </h2>
      <p className="mb-4" data-id="element-25">Damals zog ich meinen eigenen Schluss:</p>
      <blockquote className="border-l-4 border-[#2B4C7E] pl-4 italic my-6 text-xl text-gray-700 bg-gray-50 py-4 pr-4 rounded-r" data-id="element-26">
        „Mir fehlt wahrscheinlich einfach Kalzium. Also muss ich Vitamin D
        häufiger einnehmen."
      </blockquote>
      <p className="mb-4" data-id="element-27">
        Und statt der Einnahme alle zwei Tage begann ich, es jeden Tag zu
        nehmen. Ich war sicher, dass ich meinem Körper helfe.
      </p>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-28">
        Winter. Die ersten seltsamen Anzeichen
      </h2>
      <p className="mb-4" data-id="element-29">
        Der Gips wurde erst nach 4 Monaten abgenommen – alles heilte quälend
        langsam. Es wurde Winter, und ich bemerkte eine beängstigende Sache.
        Meine Hände wurden... unterschiedlich. Die linke war normal gefärbt,
        aber die rechte war blass, fast blau.
      </p>
      <p className="mb-4" data-id="element-30">
        Ich arbeite im Büro und bei uns ist es immer warm, aber ich spürte meine
        rechte Hand nicht. Sie fror ständig, es trat ein Kribbeln auf, ich
        konnte kaum noch einen Stift halten, um Dokumente zu unterschreiben. Die
        taktilen Empfindungen verschwanden: Ich merkte nicht, ob ich kaltes oder
        warmes Wasser berührte.
      </p>
      <p className="mb-4" data-id="element-31">Ich fuhr in die Notaufnahme.</p>

      <figure className="my-8" data-id="element-32">
        <img src="https://cdn.magicpatterns.com/uploads/amQgcuzBGLY5qQ5wt1qWDe/лл.jpg" alt="I'm in the hospital." className="w-full rounded-lg shadow-md" data-id="element-33" />
        <figcaption className="text-sm text-center text-gray-500 mt-2 italic" data-id="element-34">
          Meine Hände wurden unterschiedlich: die linke war normal, die rechte
          blass und kalt. Ich spürte sie kaum.
        </figcaption>
      </figure>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-35">Untersuchung</h2>
      <p className="mb-4" data-id="element-36">
        Die Ärzte vermuteten eine Durchblutungsstörung in der rechten Hand. Man
        machte einen Doppler, dann eine Angiographie. Die Vermutungen
        bestätigten sich – der Blutfluss war gestört.
      </p>

      <figure className="my-8" data-id="element-37">
        <img src="https://cdn.magicpatterns.com/uploads/3iDVLpAmaBkvgn2i69zA6G/Дизаин_без_названия.jpg" alt="Angiographie: Kalzifizierung der Gefäße" className="w-full rounded-lg shadow-md" data-id="element-38" />
        <figcaption className="text-sm text-center text-gray-500 mt-2 italic" data-id="element-39">
          Angiographie der Gefäße der rechten Hand. Die Pfeile markieren Areale
          ohne Kontrastmittelanreicherung, entsprechend Zonen mit reduziertem
          oder fehlendem Blutfluss.
        </figcaption>
      </figure>

      <DoctorComment data-id="element-40">
        <p className="mb-2" data-id="element-41">
          <strong data-id="element-42">Wo ist das ganze Kalzium geblieben?</strong>
        </p>
        <p className="mb-4" data-id="element-43">
          Es floss nicht in den gebrochenen Ellenbogen. Es lagerte sich an den
          Gefäßwänden ab. Das nennt man Kalzinose. Das Gefäß verwandelt sich in
          ein starres Rohr, der Durchlass verengt sich und das Blut erreicht die
          Extremitäten schlechter. Bleibt dies unbehandelt, kann es langfristig
          zu ernsthaften Durchblutungsstörungen führen.
        </p>
        <p className="font-semibold mb-2" data-id="element-44">
          Die Kalzifizierung verringert die Elastizität des Gefäßes und
          verschlechtert den Blutfluss – was sich äußert durch:
        </p>
        <ul className="list-disc list-inside ml-4 mb-4 space-y-1" data-id="element-45">
          <li data-id="element-46">Kältegefühl in der Hand</li>
          <li data-id="element-47">Blässe</li>
          <li data-id="element-48">Kribbeln</li>
          <li data-id="element-49">Verringerung der Empfindlichkeit</li>
          <li data-id="element-50">Schwäche</li>
        </ul>
        <p data-id="element-51">Genau diese Symptome wurden bei der Patientin beobachtet.</p>
      </DoctorComment>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-52">Operation und Ursache</h2>
      <p className="mb-4" data-id="element-53">
        Ich wurde behandelt, der Blutfluss wurde wiederhergestellt, die Hand
        kehrte allmählich zur Norm zurück. Aber die wichtigste Antwort kam erst
        später – nach der Blutanalyse.
      </p>
      <p className="mb-4" data-id="element-54">
        Der Vitamin-D-Spiegel war extrem hoch. Während der Beratung fragte mich
        der Arzt ausführlich, was und wie ich es eingenommen hatte. Und dann
        wurde klar: Das Problem lag nicht am Vitamin D selbst, sondern an der
        Dosis, der Dauer der Einnahme und dem fehlenden Gleichgewicht. Ich hatte
        es lange, ohne Kontrolle und in hoher Dosierung eingenommen.
      </p>

      <h2 className="text-2xl font-bold mt-12 mb-4" data-id="element-55">
        Was mir der Arzt erklärte
      </h2>
      <p className="mb-4" data-id="element-56">
        Vitamin D ist lebenswichtig. Aber es arbeitet nur dann richtig, wenn:
      </p>
      <ul className="list-disc list-inside ml-4 mb-6 space-y-1" data-id="element-57">
        <li data-id="element-58">die Dosis vernünftig gewählt ist</li>
        <li data-id="element-59">das Gleichgewicht mit anderen Stoffen eingehalten wird</li>
        <li data-id="element-60">
          das Alter und die Besonderheiten des Stoffwechsels berücksichtigt
          werden
        </li>
      </ul>
      <p className="mb-4" data-id="element-61">
        Andernfalls kann selbst Nützliches anders wirken als erwartet. Der Arzt
        gab mir einfache Empfehlungen, die mein Verständnis veränderten. Genau
        diese möchte ich teilen.
      </p>
    </article>;
}